import React, { Suspense } from 'react';

const _EmptyListImage = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../../assets/images/audience-list-empty.svg').then(module => ({
    default: module.ReactComponent,
  }))
);

export const EmptyListImage = () => {
  return (
    <Suspense fallback={<div style={{height: '120px', width:  '120px'}}/>}>
      <_EmptyListImage />
    </Suspense>
  );
}